import React, { useEffect, useState,useRef } from "react";
import { Card, Layout, Menu, Popover, Badge, Divider  ,Dropdown, Typography  } from "antd";
import { ReactComponent as BrandIcon } from "./../../Icons/Icon.svg";
import { ReactComponent as HamIcon } from "./../../Icons/hamburger.svg";
import { ReactComponent as VizertoIcon } from "./../../Icons/vizerto_logo_rgb_400x125 1.svg";
import { ReactComponent as HomeIcon } from "./../../Icons/home.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as HomeIconActive } from "./../../Icons/activeHome.svg";
import { ReactComponent as TrendingIcon } from "./../../Icons/trending.svg";
import { ReactComponent as TrendingActiveIcon } from "./../../Icons/TrendingIconActive.svg";
import { ReactComponent as MyFilesIcon } from "./../../Icons/myfiles.svg";
import { ReactComponent as MyFilesSelectedIcon } from "./../../Icons/MyFilesSelected.svg";
import { ReactComponent as HistoryIcon } from "./../../Icons/history.svg";
import { ReactComponent as HistorySelectedIcon } from "./../../Icons/historySelected.svg";
import { Avatar, Space } from "antd";
import { ReactComponent as BellIcon } from "./../../Icons/bell.svg";
import { ReactComponent as QMarkIcon } from "./../../Icons/mark.svg";
import SelectComp from "../Select/Select";
import { currentGroup, GROUPS } from "../../API/url";
import { updateGroups, getcurrentRoleValue, updateRoles, formatQuestionLength, momentit } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { getUserprofilePic,userLogout,clearNotifications,getUserBadgesSeeker } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import Styles from './LayoutStyles.module.css';
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { ReactComponent as SettingIcon } from "./../../Icons/settings.svg";
import { ReactComponent as SettingSelectedIcon } from "./../../Icons/settingSelected.svg";
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";
import TooltipComp from "../ToolTip/TooltipComp";
import moment from "moment";
import styles from './LayoutStyles.module.css'
import { ReactComponent as BrandSelectedIcon } from "./../../Icons/qwerty.svg";

const { Header, Content, Footer, Sider } = Layout;


const siderStyle = {
  overflow: "auto",
  height: "100vh",
  position: "fixed",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarColor: "unset",
  background: "#ffffff",
  borderRight: "1px solid #EAECF0",
  zIndex: "1000",
};
const GroupSelect = () => {
  const [option, setOptions] = useState(
    GROUPS.filter((gr) => {
      gr.label = gr.name;
      gr.value = gr.id;
      return gr;
    })
  );
  const onChangeFunc = (e) => {
    updateGroups(e);
  };
  return (
    <Card style={{ border: "none", textAlign: "start" }}>
      <div style={{ textAlign: "left" }}>
      <p
              style={{
                marginBlock: "0px",
                textAlign: "start",
                fontSize: "16px",
                fontWeight: "400",
                color: "#5C667B",
              }}
            >
              Group
            </p>
      <SelectComp
        options={option}
        placeholder="Select Group"
        size={"medium"}
        onChangeFunc={onChangeFunc}
        width={"150px"}
        val={currentGroup}
      />
    </div>
    </Card>
  );
};

const RoleSelect = () => {
  const userState = useSelector((state) => state.user);
  const profilePicState = useSelector((state) => state.profilePage.profilePic);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onToProfile=()=>{
    navigate(`${Home_PAGE_URL}profile`);
  }
  const {profilePagePictureData,advanceFilterModalToggle,getUserBadgesSeekerData,getSeekerAwardsLoaderStatus} = bindActionCreators(Actions, dispatch)
 
  const sendToAwards = () => {
    // let link = redirectionURL("awards");
    // window.location.href = link;
    advanceFilterModalToggle({ bool: true, value: "seekerAwardsModal" });
    getSeekerAwardsLoaderStatus(true)
    getUserBadgesSeeker()
      .then((res) => {
        if (res===undefined) return;
        if (res.data.success || res.data.data !== undefined) {
          getUserBadgesSeekerData(res.data.data);
          getSeekerAwardsLoaderStatus(false)
        }
      })
      .catch((err) => {
        getSeekerAwardsLoaderStatus(false)
        advanceFilterModalToggle({ bool: false, value: "seekerAwardsModal" });
        console.log(err)
      });
  };
  const fetchProfilePic = () => {
    if (profilePicState === null) {
      getUserprofilePic()
        .then((res) => {
          if (res===undefined) return;
          if (res.data.data[0].img === null) {
            profilePagePictureData("");
          } else {
            let userPic = `data:image/JPEG;base64,${res.data.data[0].img}`;
            profilePagePictureData(userPic);
          }
        })
        .catch((err) => {});
    }
  };
  // console.log(userState.roles);
  const [option, setOptions] = useState(
    userState.roles.filter((gr) => {
      gr.label = gr.roleName;
      gr.value = gr.roleId;
      return gr;
    })
  );
  const onChangeFunc = (e) => {
    updateRoles(e, userState.roles);
  };
  useEffect(()=>{
    fetchProfilePic();
  },[])
  const menuList =()=>{
    return(
        <>
        <p onClick={()=>onToProfile()} className={Styles.profileHover}>Profile</p>
        <Divider style={{margin:'0px', marginBlock:'5px'}}/>
        <p onClick={()=>userLogout()} className={Styles.profileHover}>Logout</p>
        {/* <p onClick={()=>advanceFilterModalToggle({ bool: true, value: "seekerAwardsModal" })} className={Styles.profileHover}>awards</p> */}
        </>
    )
  }
  return (
    <>
      <Card style={{ border: "none", textAlign: "start" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ marginRight: "18px" }}>
            <TooltipComp title={menuList()}>
            <Avatar 
            src={<img src={profilePicState || require('../../Images/cliente.png')} alt="avatar" />}
            size={50} style={{cursor:'pointer'}}
            // onClick={sendToAwards}
            />
            </TooltipComp>
          </div>
          <div>
            <p
              style={{
                marginBlock: "0px",
                textAlign: "start",
                fontSize: "16px",
                fontWeight: "400",
                color: "#5C667B",
              }}
            >
              {userState.firstName} {userState.lastName}
            </p>
            <SelectComp
              val={getcurrentRoleValue(userState.roles)}
              onChangeFunc={onChangeFunc}
              options={option}
              size={"medium"}
              width={"100px"}
            />
          </div>
        </div>
      </Card>
    </>
  );
};
const App = ({ children }) => {
  const userState = useSelector((state) => state.user);
  const notificationState = useSelector((state) => state.domain);
  const currentPath = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const dispatch = useDispatch();
  const {getkeyTagPayload,getSeekerAwardsLoaderStatus, getUserBadgesSeekerData,searchInputValue, updatePageNumberHistory,getAllNotifis,recommendData,preservePreviousRecommendData,trendingDataSelectPageNo,advanceFilterModalToggle} = bindActionCreators(Actions, dispatch);
  const [val, setVal] = useState(75);
  const navigate =useNavigate();
  const currentRoute = useLocation();
  const onClickCollapse = (e) => {
    setIsCollapsed(e);
    setTimeout(() => {
      setVal(e ? 75 : 200);
    }, 0);
  };
  const brandingLogo = () => {
    return `data:image/png;base64,${process.env.REACT_APP_MY_SITE_LOGO}`;
  };
  const sendToAwards = () => {
    advanceFilterModalToggle({ bool: true, value: "seekerAwardsModal" });
    getSeekerAwardsLoaderStatus(true)
    getUserBadgesSeeker()
      .then((res) => {
        if (res===undefined) return;
        if (res.data.success || res.data.data !== undefined) {
          getUserBadgesSeekerData(res.data.data);
          getSeekerAwardsLoaderStatus(false)
        }
      })
      .catch((err) => {
        getSeekerAwardsLoaderStatus(false)
        advanceFilterModalToggle({ bool: false, value: "seekerAwardsModal" });
        console.log(err)
      });
  };
  const dynamicIconRender = (key) => {
    if (key === "home") {
      if (
        currentPath.pathname === "/seekerHome/" ||
        currentPath.pathname.includes("/search")
      ) {
        return <HomeIconActive className="svgIconClassSelected" />;
      } else {
        return <HomeIcon className="svgIconClass" />;
      }
    }
    if (key === "keyterm") {
      if (
        currentPath.pathname.includes("/keyterm") || currentPath.pathname.includes("/trending")
      ) {
        return <TrendingActiveIcon className="svgIconClass" />;
      } else {
        return <TrendingIcon className="svgIconClass" />;
      }
      
    }
    if (key === "profile") {
      if (
        currentPath.pathname.includes("/profile")
      ) {
        return <SettingSelectedIcon className="svgIconClass" />;
      } else {
        return <SettingIcon className="svgIconClass" />;
      }
    }
    if (key === "download") {
      if (
        currentPath.pathname.includes("/download")
      ) {
        return <MyFilesSelectedIcon className="svgIconClass" />;
      } else {
        return <MyFilesIcon className="svgIconClass" />;
      }
    }
    if (key === "history") {
      if (
        currentPath.pathname.includes("/history")
      ) {
        return <HistorySelectedIcon className="svgIconClass" />;
      } else {
        return <HistoryIcon className="svgIconClass" />;
      }
    }
    if (key === "answered") {
      if (
        currentPath.pathname.includes("/answered") || currentPath.pathname.includes("/open") || currentPath.pathname.includes("/saved")
      ) {
        return <BrandSelectedIcon className="svgIconClass" />;
      } else {
        return <BrandIcon className="svgIconClass" />;
      }
    }
    
  };

  const items = [
    {
      label: "Home",
      key: "1",
      icon: dynamicIconRender("home"),
      route:''
    },
    {
      label: "My Questions",
      key: "2",
      icon: dynamicIconRender('answered'),
      children: [
        {
          label: "Open",
          key: "2-1",
          route:'open'
          // icon: <DashboardOutlined />,
        },
        {
          label: "Answered",
          key: "2-2",
          route:'answered'
          // icon: <SettingOutlined />,
        },
        {
          label: "Saved",
          key: "2-3",
          route:'saved'
          // icon: <DashboardOutlined />,
        },
      ],
    },
    {
      label: "Trending",
      key: "3",
      icon: dynamicIconRender('keyterm'),
      children: [
        {
          label: "Key Terms",
          key: "3-1",
          route:'keyterm'
          // icon: <DashboardOutlined />,
        },
        {
          label: "Trending Questions",
          key: "3-2",
          route:'trending'
          // icon: <SettingOutlined />,
        },
        // {
        //   label: "Questions",
        //   key: "3-3",
        //   // icon: <DashboardOutlined />,
        // },
      ],
    },
    {
      label: "My Files",
      key: "4",
      icon: dynamicIconRender('download'),
      route:'download'
    },
    {
      label: "History",
      key: "5",
      icon:dynamicIconRender('history'),
      route:'history/',
      // danger:true
    },
    {
      label: "Profile",
      key: "6",
      icon: dynamicIconRender('profile'),
      route:'profile'
    },
    {
      label: "Awards",
      key: "7",
      icon: <i style={{height:'21px',width:'21px',fontSize:'21px', color:'#5C667B',marginLeft:'-2px'}} className="fa fa-trophy"></i>,
      route:''
    }
  ];

  let agentsItem =[{
    label: "Agents",
    key: "8",
    icon: <i style={{height:'21px',width:'21px',fontSize:'21px', color:'#5C667B'}} className="fa fa-user-secret"></i>,
    children: [
      {
        label: "Briefing Agent",
        key: "7-1",
        route:'brief'
      },
      {
        label: "Saved Briefs",
        key: "7-2",
        route:'savebrief'
      },
    ],
  },]


  const onClickIcons=(e)=>{
    getkeyTagPayload(null);
    const {key} = e;
    if(key==='7-1'){
      searchInputValue('');
      navigate(`${Home_PAGE_URL}brief`);
    }
    if(key==='7-2'){
      searchInputValue('');
      navigate(`${Home_PAGE_URL}savebrief`);
    }
    if(key==='1'|| key==='2-1'|| key==='2-2'|| key==='2-3'|| key==='4'|| key==='6'){
      searchInputValue('');
      items.filter(obj=>{
        if(obj.key==key){
          navigate(`${Home_PAGE_URL}${obj.route}`);
        }
        if(obj.children !== undefined){
          obj.children.filter(obj2=>{
            if(obj2.key==key){
              navigate(`${Home_PAGE_URL}${obj2.route}`);
            }
          })
        }
      });
    }
    if(key==='3-1'){
      getkeyTagPayload(null);
      items.filter(obj=>{
        if(obj.key==key){
          navigate(`${Home_PAGE_URL}${obj.route}`);
        }
        if(obj.children !== undefined){
          obj.children.filter(obj2=>{
            if(obj2.key==key){
              navigate(`${Home_PAGE_URL}${obj2.route}`);
            }
          })
        }
      });
    }
    if(key==='3-2'){
      trendingDataSelectPageNo(0);
      items.filter(obj=>{
        if(obj.key==key){
          navigate(`${Home_PAGE_URL}${obj.route}`);
        }
        if(obj.children !== undefined){
          obj.children.filter(obj2=>{
            if(obj2.key==key){
              navigate(`${Home_PAGE_URL}${obj2.route}`);
            }
          })
        }
      });
    }
    if(key==='5'){
      updatePageNumberHistory(0);
      items.filter(obj=>{
        if(obj.key==key){
          navigate(`${Home_PAGE_URL}${obj.route}`);
        }
        if(obj.children !== undefined){
          obj.children.filter(obj2=>{
            if(obj2.key==key){
              navigate(`${Home_PAGE_URL}${obj2.route}`);
            }
          })
        }
      });
    }
    if(key==='7'){
      sendToAwards();
    }
    // navigate(`/seekerHome/${key}`);
  }
  const unreadNotificationCounter = () => {
    let counter = 0;
    if (notificationState.notifications.length > 0) {
      notificationState.notifications.filter((notif) => {
        if (notif.data.status === "null") {
          counter += 1;
        }
      });
    } else {
      counter = 0;
    }
    return counter;
  };

  const selectedTab =()=>{
      if (currentPath.pathname === "/seekerHome/" ||currentPath.pathname.includes("/search")) {
        return ['1'];
      } 
      if (currentPath.pathname.includes("/keyterm")) {
        return ['3-1'];
      }
      if (currentPath.pathname.includes("/profile")) {
        return ['6'];
      } 
      if (currentPath.pathname.includes("/download")) {
        return ['4'];
      } 
      if (currentPath.pathname.includes("/history")) {
        return ['5'];
      } 
      if (currentPath.pathname.includes("/answered")) {
        return ['2-2'];
      } 
      if (currentPath.pathname.includes("/open")) {
        return ['2-1'];
      }
      if (currentPath.pathname.includes("/brief")) {
        return ['7-1'];
      }
      if (currentPath.pathname.includes("/savebrief")) {
        return ['7-2'];
      }
      if (currentPath.pathname.includes("/saved")) {
        return ['2-3'];
      } 
      if (currentPath.pathname.includes("/trending")) {
        return ['3-2'];
      } 
  }


  const onClickClearNotification = () => {
    let newNotifications = notificationState.notifications.filter((notif) => {
      notif.data.status = null;
      return notif;
    });
    getAllNotifis(newNotifications);
    clearNotifications();
  
  };
    const openNotification = (data) => {
      getkeyTagPayload(null);
    if(data.data.msgType === 'rfp_file_processed'){
      let newNotifications = notificationState.notifications.filter((notif) => {
        if (data.data.msgUuid === notif.data.msgUuid) {
          notif.data.status = null;
        }
        return notif;
      });
      getAllNotifis(newNotifications);
      navigate(`${Home_PAGE_URL}download`);
      return;
    }
    let newNotifications = notificationState.notifications.filter((notif) => {
      if (data.data.msgUuid === notif.data.msgUuid) {
        notif.data.status = null;
      }
      return notif;
    });
    getAllNotifis(newNotifications);
    recommendData(data);
    if (!currentRoute.pathname.includes(`${Home_PAGE_URL}recommend`)) {
      preservePreviousRecommendData([]);
    }
    navigate(`${Home_PAGE_URL}recommend`);
  };


const NotificationDropdown = () => {
  const menuItems = notificationState.notifications.length > 0
    ? [
        {
          key: "mark-all",
          label: (
            <div style={{ cursor: "pointer", textAlign: "right",fontSize:"16px",fontFamily:"inter" }}>
              <h6 onClick={()=>onClickClearNotification()}>Mark All As Read</h6>
              <Divider style={{margin:'0px', marginBlock:'5px'}}/>
            </div>
          ),
        },
        ...notificationState.notifications.map((notif, index) => (
          {
            
          key: index,
          label: (
            <>
            <div
               className={` ${
                notif.data.status === "null" || notif.data.status === 1 ? "notificationBGColor" : "notification-item"
              }`}

              onClick={() => openNotification(notif)}
            >
              <div style={{
                padding:notif.data.status === "null" || notif.data.status === 1 ?"8px":"0px",
                backgroundColor:   notif.data.status === "null" || notif.data.status === 1 ?"#f0fbff":"",
            
                borderRadius:"6px",
                }}>

              
              <h4 style={{  overflow: "hidden",textOverflow: "ellipsis", color: "#444444",fontFamily:"inter",fontSize: "14px",textAlign: "left",fontWeight: "normal",marginTop: "4px",}}>
                <i className={notif.icon}></i>&nbsp;{notif.header}
              </h4>
              <h5 style={{overflow: "hidden",textOverflow: "ellipsis",color: "#444444",fontFamily:"inter",fontSize: "14px", textAlign: "left", fontWeight: "normal",marginTop: "4px",
  }}>
                {notif.notification.title}
                {notif.notification.title !== "" && <br />}
                <span style={{fontSize:"14px",fontFamily:"inter",fontWeight:"500"}}>"{formatQuestionLength(notif.data.extraInfo)}"</span>
              </h5>
              <h5 style={{   color: "#888",fontSize: "12px", fontFamily:"inter",fontWeight: "normal",}}>
              {momentit(notif.data.creationDate)}
              </h5>
              </div>
            </div>
            <Divider style={{margin:'0px', marginBlock:'5px'}}/>
            </>
          ),
        })),
      ]
    : [
        {
          key: "no-notifications",
          label: (
            <span className="no-notifications">
              No notification available!
            </span>
          ),
        },
      ];

  return (
    <Dropdown
      overlay={
        <Menu
          items={menuItems}
          style={{ width: "338px", maxHeight: "300px", overflowY: "auto", fontSize: "12px",
          }}
        />
      }
      trigger={["hover"]}
      // trigger={["click"]}
      placement="bottomRight"
    >
     
      <Badge 
      count={unreadNotificationCounter()}
      // count={notificationState.notifications.length}
      style={{backgroundColor:"#00D1FF",cursor:"pointer"}}
      >
          <Avatar style={{background:'#fff',cursor:"pointer"}}  shape="round" icon={<BellIcon />} />
                  </Badge>
    </Dropdown>
  );
}


  return (
    <Layout hasSider>
      <Sider
        trigger={null}
        collapsed={isCollapsed}
        collapsedWidth={"75px"}
        onCollapse={(val) => onClickCollapse(val)}
        collapsible
        style={siderStyle}
        
      >
        <div
          style={{
            height: "80px",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          {!isCollapsed && (
            <div style={{ cursor: "pointer", width:'110px', height:'35px'}}>
              <img
              src={brandingLogo()}
              style={{  width:'100%', height:'100%', objectFit:'contain'}}
              onClick={() => navigate(Home_PAGE_URL)}
            />
            </div>
          )}
          <HamIcon
            style={{ cursor: "pointer" }}
            onClick={() => onClickCollapse(!isCollapsed)}
          />
        </div>
        <div className="demo-logo-vertical" />
        <Menu          
          selectedKeys={selectedTab()}
          items={userState.agenticEnabled?items.concat(agentsItem):items}
          style={{ border: "none" }}
          onClick={(e)=>onClickIcons(e)}
        />
      </Sider>
      <Layout
        style={{
          marginInlineStart: val,
        }}
      >
        <Header
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            width: "100%",
            display: "flex",
            alignItems: "center",
            height: "80px",
            background: "#FFFFFF",
            borderBottom: "1px solid #EAECF0",
            paddingInline: "10px",
          }}
        >
          <div style={{ textAlign: "right", width: "100%" }}>
            <div>
              {" "}
              <Space wrap size={18}>
                {/* <span><NavButtonIcon/>&nbsp;<span style={{color:'#5C667B', fontSize:'14px',lineHeight:'24px', fontWeight:'400'}}>Average response time: <span>03 minutes</span></span></span> */}
                <TooltipComp title={'Urgent'}>
                <Badge size="medium" style={{background:'#FF6600'}}  count={`${
                    userState?.fastTrackInfo === undefined
                      ? 0
                      : userState.fastTrackInfo.total -
                        userState.fastTrackInfo.used
                  }`}>
                 <Avatar style={{background:'#fff'}}  shape="round" icon={<FireIcon />} />
                  </Badge>
                </TooltipComp>
                <NotificationDropdown/>
                {/* <Popover content={'NotificatioLayoutns'} title=""> */}
                  {/* <BellIcon style={{cursor:'pointer'}} /> */}
                  {/* </Popover> */}
                <RoleSelect />
                <GroupSelect />
              </Space>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "0px 0px 0px",
            overflow: "initial",
          }}
        >
          <div
            style={{
              padding: 24,
              // textAlign: "center",
              background: "#FCFCFD",
              // margin:'auto',
              // width:'80%'
            }}
          >
            {children}
          </div>
        </Content>
        <Footer
          style={{
            position: "fixed",
            bottom: "0",
            width: "100%",
            height: "50px",
            display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
            padding: "0px",
            // marginLeft: "-2.5%",
            background: "#FFFFFF",
            borderTop: "1px solid #EAECF0",
          }}
        >
          <div style={{ width: "33%" }}></div>
          <div
            style={{
              width: "34%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "-5%",
            }}
          >
            <img
              src={require("../../Images/vizerto_icon.jpg")}
              style={{ width: "24px", height: "24px" }}
            />
            &nbsp;
            <span
              style={{
                color: "#ACB6C6",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "22px",
              }}
            >
              Vizerto Copyright 2025-2026
            </span>
          </div>
          <div style={{ width: "33%" }}></div>
        </Footer>
      </Layout>
    </Layout>
  );
};
export default App;
